// extracted by mini-css-extract-plugin
module.exports = {"header":"header-aHI--gF_ clearfix","logo":"logo-m_LwLFt4"};